import { useTranslation } from 'react-i18next';

export function useT() {
  const { t } = useTranslation('common');
  return (key: string, options?: Record<string, unknown>) => t(key, options);
}

export { default as i18nInstance } from '../i18n';
